import Swiper, { Navigation, Pagination } from 'swiper'

const mainSliderIndex = new Swiper('.main-slider', {
  loop: false,
  modules: [
    Navigation,
    Pagination
  ],

  pagination: {
    el: '.main-slider__swiper-pagination',
    type: 'fraction',
  },

  navigation: {
    nextEl: '.main-slider__next',
    prevEl: '.main-slider__prev',
  },

  spaceBetween: 20,
})
